export const TRIP_UPDATE_TYPE = {
    MISSED: 'MISSED',
    CANCELED: 'CANCELED',
    REINSTATE_TRIP: 'REINSTATE_TRIP',
    SKIPPED: 'SKIPPED',
    REINSTATE_STOP: 'REINSTATE_STOP',
    PLATFORM_CHANGE: 'PLATFORM_CHANGE',
    COPY_TRIP: 'COPY_TRIP',
};

export const PLATFORM_CHANGE_SOURCE = {
    SYSTEM: 'SYSTEM',
    MANUAL: 'MANUAL',
};

export const TRIP_FINAL_STATUS = {
    MISSED: 'MISSED',
    CANCELED: 'CANCELED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
};

export const TIME_TYPE = {
    Scheduled: 'scheduledTime',
    Actual: 'actualTime',
};

export const TRIP_DETAIL_ICON_TYPE = {
    ADDED: 'ADDED',
    DISRUPTION: 'DISRUPTION',
};
